import React from 'react';
import {useSelector} from "react-redux";

import styles from './MyOrder.module.scss';
import myOrder from '../../constants/images/my-order-default.svg';
import geo from '../../constants/images/myOrderIcons/geo-location-icon.svg';
import cart from '../../constants/images/myOrderIcons/cleaning-cart.svg';
import creditCard from '../../constants/images/myOrderIcons/credit-card.svg';
import clock from '../../constants/images/myOrderIcons/date-clock.svg';
import MyOrderMobile from "./MyOrderMobile/MyOrderMobile";
import tag from "../../constants/images/myOrderIcons/tag-icon.svg";
import AppAccordion from "../UI/AppAccordion/AppAccordion";

const MyOrder = () => {

    const {
        selectedCity,
        street,
        buildingNumber,
        entrance,
        apartment,
        service_package,
        services,
        finalPrice,
        selectedDate,
        selectedTime,
        request_datetime,
        request_price,
    } = useSelector(state => state.stepperInfo);

    const formatAddress = (street, buildingNumber, entrance, apartment) => {
        let address = '';

        if (street) {
            address += street + ', ';
        }
        if (buildingNumber) {
            address += 'буд. ' + buildingNumber + ', ';
        }
        if (entrance) {
            address += 'під. ' + entrance + ', ';
        }
        if (apartment) {
            address += 'кв. ' + apartment;
        }

        return address;
    }

    return (
        <>
            <div className={styles.myOrder}>
                <h2 className={styles.myOrder_title}>Моє замовлення</h2>

                {
                    ((!!selectedCity || (!!street || !!buildingNumber || !!entrance || !!apartment) || !!service_package.name || services.length > 0)) ?
                        <div className={styles.myOrder_info}>
                            {
                                ((selectedCity || (!!street || !!buildingNumber || !!entrance || !!apartment))) &&
                                <div className={styles.myOrder_info_addressContainer}>
                                    <div className={styles.myOrder_info_addressContainer_icon}>
                                        <img src={geo} alt="geo location icon"/>
                                    </div>

                                    <div className={styles.myOrder_info_addressContainer_address}>
                                        {
                                            ((!!street || !!buildingNumber || !!entrance || !!apartment)) &&
                                            <p>{formatAddress(street, buildingNumber, entrance, apartment)}</p>
                                        }
                                        <p>{selectedCity}</p>
                                    </div>
                                </div>
                            }

                            {(!!service_package.name) &&
                                <div className={styles.myOrder_info_package}>
                                    <div className={styles.myOrder_info_package_icon}>
                                        <img src={tag} alt="tag icon"/>
                                    </div>

                                    <div className={styles.myOrder_info_package_services}>
                                        {
                                            (service_package.name === 'Індивідуальний пакет') ?
                                                service_package.name :
                                                <AppAccordion
                                                    type={'Назва пакету'}
                                                    title={service_package.name}
                                                />
                                        }
                                    </div>
                                </div>}

                            {(services?.length > 0) &&
                                <div className={styles.myOrder_info_additionalServices}>
                                    <div className={styles.myOrder_info_additionalServices_icon}>
                                        <img src={cart} alt="cart icon"/>
                                    </div>

                                    <div className={styles.myOrder_info_additionalServices_services}>
                                        {
                                            <AppAccordion
                                                type={'Додаткові послуги'}
                                                title={'Додаткові послуги'}
                                            />
                                        }
                                    </div>
                                </div>}

                            {(finalPrice > 0) &&
                                <div className={styles.myOrder_info_price}>
                                    <div className={styles.myOrder_info_price_icon}>
                                        <img src={creditCard} alt="credit card icon"/>
                                    </div>

                                    <div className={styles.myOrder_info_price_finalPrice}>
                                        <p>Орієнтовна вартість</p>
                                        <p>₴{finalPrice}</p>
                                    </div>
                                </div>}

                            {!!request_price && <div className={styles.myOrder_info_price}>
                                <div className={styles.myOrder_info_price_icon}>
                                    <img src={creditCard} alt="credit card icon"/>
                                </div>

                                <div className={styles.myOrder_info_price_finalPrice}>
                                    <p>Ви пропонуєте</p>
                                    <p>₴{request_price}</p>
                                </div>
                            </div>}

                            {(request_datetime || selectedTime) &&
                                <div className={styles.myOrder_info_dateAndTime}>
                                    <div className={styles.myOrder_info_dateAndTime_icon}>
                                        <img src={clock} alt="clock icon"/>
                                    </div>

                                    <div className={styles.myOrder_info_dateAndTime_dateAndTime}>
                                        <p>{new Date(request_datetime).toLocaleDateString()}</p>
                                        <p>{selectedTime}</p>
                                    </div>
                                </div>}
                        </div> :
                        <>
                            <img className={styles.myOrder_icon} src={myOrder} alt="my order icon"/>
                            <div className={styles.myOrder_description}>
                                <p>Привіт!</p>
                                <p>Ми чекаємо вашого замовлення, щоб потурбуватись про вашу чистоту.</p>
                            </div>
                        </>
                }
            </div>
            <MyOrderMobile/>
        </>
    );
};

export default MyOrder;
